import script from "./BasePromocode.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasePromocode.vue?vue&type=script&lang=ts&setup=true"

import "./BasePromocode.vue?vue&type=style&index=0&id=1825c989&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1825c989"]])

export default __exports__